

























































































































import Vue from 'vue'
import CategoryPostBreadcrumbs from '@/components/common/CategoryPostBreadcrumbs.vue'
import VideoPlayer from '@/components/product/VideoPlayer.vue'
import PostQueue from '@/components/product/PostQueue.vue'
import InstructorCard from '@/components/product/InstructorCard.vue'
import PostMaterialsCard from '@/components/product/PostMaterialsCard.vue'
import GoToNextPost from '@/components/product/GoToNextPost.vue'
import CommentList from '@/components/comments/CommentList.vue'
import QuizStatusComponent from '@/components/assessments/QuizStatusComponent.vue'
import AssignmentStatus from '@/components/assessments/AssignmentStatus.vue'

export default Vue.extend({
  components: {
    CategoryPostBreadcrumbs,
    QuizStatusComponent,
    VideoPlayer,
    PostQueue,
    PostMaterialsCard,
    InstructorCard,
    GoToNextPost,
    CommentList,
    AssignmentStatus
  },
  props: {
    product: {
      type: Object
    },
    instructor: {
      type: Object
    },
    activePost: {
      type: Object
    },
    category: {
      type: Object
    },
    videoOptions: {
      type: Object
    },
    nextPost: {
      type: Object
    },
    playlist: {
      type: Array
    },
    disableActions: {
      type: Object
    },
    nextCategoryId: String,
    markCompletedBtnCss: String,
    postCompletionButtonText: String,
    lessonButton: Object,
    isAdmin: Boolean,
    nextLesson: String,
    fetchingPost: Boolean,
    fetchingPostCompletionStatus: Boolean,
    disablePostCompletionButton: Boolean,
    completedPostIds: {
      type: Set,
      default: new Set()
    }
  },
  data() {
    return {
      post: {},
      canRetakeQuiz: false
    }
  },
  computed: {
    currentPostContentType(): string {
      return this.activePost && this.activePost.contentType
    },
    productId(): string {
      return this.$route.params.id
    },
    categoryId(): string {
      return this.$route.params.category_id
    },
    postId(): string {
      return this.$route.params.post_id
    }
  },
  methods: {
    goToNextPost() {
      this.$router.push({
        name: 'post-overview',
        params: {
          id: this.productId,
          category_id: this.nextPost.categoryId,
          post_id: this.nextPost.postId
        },
        query: {
          template_id: this.templateId
        }
      })
    },
    togglePostCompletion() {
      this.$emit('togglePostCompletion')
    },
    changeQuizStatus(quizRetake: boolean) {
      this.canRetakeQuiz = quizRetake
    }
  }
})
